





































































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import {
  filter, sort, map, clone,
} from 'ramda'
import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import {
  getModule,
} from 'vuex-module-decorators'
import {
  CouponType, CouponTemplateType, CustomerType,
} from '../../types'
import { db } from '../../firebase/init'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import CardList from '../../components/layout/CardList.vue'
import SingleCustomer from '../../components/customers/SingleCustomer.vue'
import CDatePicker from '../../components/inputs/CDatePicker.vue'
import FindCustomer from '../../components/customers/FindCustomer.vue'
import AddCoupon from '../../components/coupons/AddCoupon.vue'
import CouponCategories from '../../components/coupons/CouponCategories.vue'

const CouponCollection = collection<CouponType>('coupons')
const AnonCouponCollection = collection<CouponType>('anonCoupons')

// const uppercase = (x:string) => {
//   const words = x.split(' ').map((s:string) => s.charAt(0).toUpperCase() + s.slice(1)).join(' ')
//   return words.map((s:string) => s.charAt(0).toUpperCase() + s.slice(1)).join(' ')
// }

@Component({
  components: {
    CardList,
    CDatePicker,
    SingleCustomer,
    FindCustomer,
    AddCoupon,
    CouponCategories,
  },
})

export default class ManageCoupons extends Mixins(MainMixin) {
  tabs = [{ title: 'Add New', value: 'new' }, { title: 'Templates', value: 'templates' }, { title: 'Categories', value: 'categories' }]

  $refs:any

  loading = false

  $vuetify:any

  get couponColumns() {
    if (this.$vuetify.breakpoint.mdAndUp) {
      if (this.couponCodes.length < 5) {
        return '12'
      } return '4'
    } if (this.couponCodes.length < 5) {
      return '12'
    } return '6'
  }

  baseData() {
    return {
      comments: [],
      group: this.$store.getters.group,
      created: new Date(),
      redeemedBy: '',
      redemptionNotes: '',
      spend: null,
      redeemed: null,
    }
  }

  baseTemplateData() {
    return {
      group: this.$store.getters.group,
      created: new Date(),
    }
  }

  async addCoupon() {
    const valid = await this.$refs.couponForm.$refs.obs.validate()
    if (!this.$refs.couponForm.isValid()) return this.$toast.error('Please Choose Customer')
    console.log('valid is: ', valid)
    if (valid) {
      this.loading = true
      const newCoupon:CouponType = Object.assign(this.$refs.couponForm.coupon, this.baseData())
      const { data } = this.$refs.couponForm
      if (data.couponType === 'Single Known Customer') {
        console.log('newCoupon is asdfasdf: ', newCoupon)
        const result = await add(CouponCollection, newCoupon)
        console.log('Coupon Added', result)
        this.loading = false
        this.resetCoupon()
        return this.$toast.success('Coupon Successfully Added!')
      }
      if (data.couponType === 'Multi Use Code') {
        const couponId = await db.collection('anonCoupons').where('codes', 'array-contains', data.newCouponId.toUpperCase()).get()
        if (!couponId.empty) {
          this.$toast.warning('This Coupon ID is Already In Use - Please Choose Another Name')
          this.$refs.couponForm.data.newCouponId = ''
          this.loading = false
          return true
        }
        newCoupon.codes = [data.newCouponId.toUpperCase()]
        const result = await add(AnonCouponCollection, newCoupon)
        console.log('Coupon Added', result)
        this.loading = false
        this.resetCoupon()
        return this.$toast.success(`Coupon "${data.newCouponId}" Successfully Created!`)
      } if (data.couponType === 'Single Use Codes') {
        console.log('making single use codes')
        const codes = await this.generateCouponCodes(data.numberOfCodes)
        if (!codes) {
          this.loading = false
          throw new Error('Error Creating Coupon Codes')
        }
        this.couponCodes = codes
        newCoupon.codes = codes
        const result = await add(AnonCouponCollection, newCoupon)
        console.log('Coupon Added', result)
        this.loading = false
        this.showCodeDialog = true
        this.resetCoupon()
        return this.$toast.success('Coupon Codes Successfully Created!')
      }
    } return false
  }

  resetTemplate() {
    console.log('going here 2: ', this.$refs.templateForm)
    this.$refs.templateForm.reset()
  }

  resetCoupon() {
    console.log('going here4: ', this.$refs.couponForm)
    this.$refs.couponForm.reset()
  }

  async addTemplate() {
    console.log('this.$refs.templateForm', this.$refs.templateForm)
    const valid = await this.$refs.templateForm.$refs.obs.validate()
    if (!this.$refs.templateForm.isValid) return this.$toast.error('Invalid Data - Please Check')
    console.log('valid is: ', valid)
    if (valid) {
      const newTemplate:CouponTemplateType = Object.assign(this.$refs.templateForm.coupon, this.baseData())
      newTemplate.name = newTemplate.name.toLowerCase().trim()
      this.loading = true
      const templateExists = await db.collection('couponTemplates').doc(newTemplate.name).get()
      if (templateExists && templateExists.exists) {
        this.$refs.templateForm.coupon.name = ''
        return this.$toast.error('Template Name Exists - Please Choose Another Name')
      }
      if (newTemplate.expires) newTemplate.expires = newTemplate.expires.trim().toLowerCase()
      const result = await db.collection('couponTemplates').doc(newTemplate.name).set(newTemplate)
      console.log('result: ', result)
      this.loading = false
      this.resetTemplate()
      return this.$toast.success('Coupon Template Successfully Created!')
    } return this.$toast.error('Error Creating Template')
  }

  showCodeDialog = false

  couponCodes:string[] = []

  async generateCouponCodes(n:number) {
    const { lastCoupon } = this.$store.state.location.data
    if (!lastCoupon) return false
    const starter = lastCoupon.substr(0, 2)
    const startNum = Number(lastCoupon.substr(2))
    const codes = []
    await db.collection('locations').doc(this.$store.getters.location).update({ lastCoupon: `${starter}${startNum + n}` })
    for (let i = 0; i < n; i += 1) {
      const random = (Math.random().toString(36).substring(2, 5) + Math.random().toString(36).substring(2, 5)).substr(0, 5)
      codes.push(`${random}${starter}${startNum + i + 1}`.toUpperCase())
    }
    return codes
  }

  loadedTemplates = false

  async created() {
    if (!this.$store.state.location.couponTemplates || this.$store.state.location.couponTemplates.length === 0) {
      const result = await this.$store.dispatch('bindCouponTemplates')
      console.log('result: ', result)
    } this.loadedTemplates = true
  }
}

